import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForRouteWiseCropDetails } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { RouteWiseCropDetailsReportSchemaObject } from "../RouteWiseCropDetailsReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import '../Pages/tableFooter.css';
import _ from 'lodash';

const screenCode = "ROUTEWISECROPDETAILSREPORT";

export function RouteWiseCropDetailsReport(props) {

    const componentRef = useRef();
    const [fullTotalRow, setFullTotalRow] = useState([]);
    const [csvTotalRow, setCsvTotalRow] = useState([]);
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [total, setTotal] = useState({
        totalWeight: 0,
        totalNetWeight: 0
    });

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: ""
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(RouteWiseCropDetailsReportSchemaObject).options({ allowUnknown: true });
    const [contentRowNames, setContentRowNames] = useState([]);

    const [csvHeaders, setCsvHeaders] = useState([]);

    const [reportData, setReportData] = useState([]);
    const [columnNames, setColumnNames] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"
        });
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0"
        });
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            fromDate: target.value,
        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            toDate: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, RouteWiseCropDetailsReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROUTEWISECROPDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getRouteWiseCropeDetailsReportData(leafCollectionDetails);

        var collectionTypesNamesArray = [];
        var contentRowNamesArray = [];
        var reportDataArray = [];
        var filteredReportDataArray = [];
        var collectionTypesKeyValues = [];

        
        var totRecord = {
            collectionPointID: "Total",
        };

        collectionTypesNamesArray.push("Route Name");
        contentRowNamesArray.push("collectionPointID");

        result.forEach(x => {
            collectionTypesNamesArray.push((x.collectionTypeName + " /Kg"));
            contentRowNamesArray.push(x.collectionTypeID);
            collectionTypesKeyValues.push({name: x.collectionTypeName, value: x.collectionTypeID})

            reportDataArray.push({
                collectionPointID: x.collectionPointName,
                [x.collectionTypeID]: x.amount,
                collectionPointIdNumber: x.collectionPointID,
                collectionTypeID: x.collectionTypeID,
                amount: x.amount,
                name: x.collectionPointName
            });
        });

        var uniqCollectionTypesNamesArray = collectionTypesKeyValues.filter((v,i,a)=>a.findIndex(t=>(t.name === v.name && t.value===v.value))===i);

        collectionTypesNamesArray.push("Total");
        contentRowNamesArray.push("total");
        reportDataArray.forEach(x => {
            if (filteredReportDataArray.length === 0) {
                filteredReportDataArray.push(x);
            } else {
                var selectedRecord = filteredReportDataArray.find(y => y.collectionPointIdNumber === x.collectionPointIdNumber);

                if (selectedRecord) {
                    for (const item in selectedRecord) {
                        if (parseInt(item) === parseInt(x.collectionTypeID)) {
                            selectedRecord[item] = selectedRecord[item] + x.amount;
                        } else {
                            if (!isNaN(item)) {
                                selectedRecord[x.collectionTypeID] = x.amount;
                            }
                        }
                    }
                } else {
                    filteredReportDataArray.push(x);
                }
            }
        });

        var uniqContentRowNamesArray = [...new Set(contentRowNamesArray)];

        setColumnNames([...new Set(collectionTypesNamesArray)]);
        setContentRowNames(uniqContentRowNamesArray);
        

        filteredReportDataArray.forEach((x, i) => {
            for (const item in x) {
                if (!isNaN(item)) {
                    x.total = (x.total === undefined ? 0 : x.total) + parseFloat(x[item]);
                    totRecord[item] = (totRecord[item] === undefined ? 0 : parseFloat(totRecord[item]))
                        + parseFloat(x[item]);
                }
            }
            totRecord.total = ((totRecord.total === undefined ? 0 : parseFloat(totRecord.total)) + parseFloat(x.total)).toFixed(2);
        });
        setCsvTotalRow(totRecord);
        calculateTotal(filteredReportDataArray);

        var csvHeaders = [{ label: "Route name", value: "collectionPointID" }];

        uniqContentRowNamesArray.forEach(x => {
            if (!isNaN(x)) {
                var selectedItem = uniqCollectionTypesNamesArray.find(y => y.value === x);
                csvHeaders.push({
                    label: selectedItem.name, value: x
                })
            }
        });

        csvHeaders.push({ label: "Total", value: "total" });

        if (result.length > 0) {
            destroyDataTable();
            setIsTableHide(false);
            setReportData(filteredReportDataArray);
            createDataTable();
            setCsvData(filteredReportDataArray);
            setCsvHeaders(csvHeaders);
        }
    }
    function calculateTotal(data) {
        var total = [];

        data.forEach(x => {
            for (var property in x) {
                if (property !== "collectionPointID" && property !== "collectionPointIdNumber" && property !== "collectionTypeID" && property !== "name" && property !== "amount") {
                    total.push({ name: property, value: x[property] });
                }
            }
        });

        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, (m.get(name) || 0) + value), new Map
        ), ([name, value]) => ({ name, value }));

        setFullTotalRow(res);
        return res;
    }

    function createDataTable() {
        $("#routeWiseCropDetails").DataTable();
    }

    function destroyDataTable() {
        $("#routeWiseCropDetails").DataTable().destroy();
    }

    function createFile() {
        var settings = {
            sheetName: 'Route Wise Crop Details',
            fileName: 'RouteWiseCropDetailsReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        copyOfCsv.push(csvTotalRow)
        xlsx(csvHeaders, copyOfCsv, settings, true);
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            collectionTypeID: "0",
            fromDate: "",
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Route Wise Crop Details Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div className="pt-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="routeWiseCropDetails" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            {columnNames.map((x, index) => {
                                                                return (
                                                                    <th key={index}>{x}</th>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForRouteWiseCropDetails
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th>Total</th>
                                                            {contentRowNames.map((x, i) => {
                                                                var res = fullTotalRow.find(y => y.name === x.toString());
                                                                if (res) {
                                                                    return (
                                                                        <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                                    );
                                                                }
                                                            })}
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-3">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Route Wise Crop Details Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} total={total} fullTotalRow={fullTotalRow}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} columnNames={columnNames} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
